import type { AgentItem } from "./agent-items"

// The home shows a short list so the work reads as doable; the rest sit behind "Show more".
export const AGENT_HOME_TODO_LIMIT = 3

export interface AgentHomeTodo {
	id: string
	title: string
	// Support chats behind the idea, when the idea counts them.
	chats: number | null
}

function chatCount(item: AgentItem): number | null {
	return item.kind === "recommendation"
		? item.recommendation.conversationCount
		: null
}

/** Open setup steps first, then every idea, the ones that reach the most support chats first. */
export function agentHomeTodos(
	items: readonly AgentItem[],
	titleOf: (item: AgentItem) => string,
): AgentHomeTodo[] {
	const isSetup = (item: AgentItem) => (item.kind === "setup" ? 1 : 0)
	return items
		.map((item, index) => ({ item, index, chats: chatCount(item) }))
		.sort(
			(a, b) =>
				isSetup(b.item) - isSetup(a.item) ||
				(b.chats ?? 0) - (a.chats ?? 0) ||
				a.index - b.index,
		)
		.map(({ item, chats }) => ({ id: item.id, title: titleOf(item), chats }))
}

export const chatsLabel = (chats: number) =>
	chats === 1 ? "1 chat" : `${chats} chats`

/** The first rows the card always shows, and the rest behind "Show more". */
export function splitHomeRows<T>(rows: readonly T[]): {
	head: readonly T[]
	rest: readonly T[]
} {
	return {
		head: rows.slice(0, AGENT_HOME_TODO_LIMIT),
		rest: rows.slice(AGENT_HOME_TODO_LIMIT),
	}
}
